import React from 'react';

import { Section, Grid } from '@gogame/components';
import { FormField } from '@gogame/form';

import DateRangeWithConstants from 'scenes/CustomAudiences/Audiences/components/AudienceForm/DateRangeWithConstants';
import { DEPOSITORS } from 'scenes/CustomAudiences/Audiences/components/AudienceForm/constants';
import { useCanEditAll } from 'scenes/CustomAudiences/EditGranularityContext';

import TopDepositorsFormField from './TopDepositorsFormField';
import {
  PERIOD,
  COUNT,
  AMOUNT,
  DAYS_SINCE_LAST_DEPOSIT,
  DAYS_TO_DEPOSIT,
} from './constants';

const FieldSet = () => {
  const canEditAll = useCanEditAll();
  return (
    <Section title={'Depositors'}>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <DateRangeWithConstants
            name={`${DEPOSITORS}.${PERIOD}`}
            label={'Last deposit period'}
            padding={0}
            disabled={!canEditAll}
          />
        </Grid>
        <Grid item xs={3}>
          <FormField.TextField
            type={'number'}
            name={`${DEPOSITORS}.${DAYS_TO_DEPOSIT}`}
            label={'Days to deposit'}
            padding={0}
            placeholder={'0'}
            disabled={!canEditAll}
          />
        </Grid>
        <Grid item xs={3}>
          <FormField.TextField
            type={'number'}
            name={`${DEPOSITORS}.${DAYS_SINCE_LAST_DEPOSIT}`}
            label={'Days since last deposit'}
            padding={0}
            placeholder={'0'}
            disabled={!canEditAll}
          />
        </Grid>
        <Grid item xs={3}>
          <FormField.TextField
            range={true}
            name={`${DEPOSITORS}.${AMOUNT}`}
            label={'Deposits amount'}
            padding={0}
            disabled={!canEditAll}
          />
        </Grid>
        <Grid item xs={3}>
          <FormField.TextField
            range={true}
            name={`${DEPOSITORS}.${COUNT}`}
            label={'Deposits count'}
            padding={0}
            disabled={!canEditAll}
          />
        </Grid>
        <Grid item xs={12}>
          <TopDepositorsFormField disabled={!canEditAll} />
        </Grid>
      </Grid>
    </Section>
  );
};

export default FieldSet;
